import { addMessages, init, locale } from 'svelte-i18n';
import { setDefaultOptions } from 'date-fns';
import * as locales from 'date-fns/locale';

import { getBootstrap } from '@client/app/bootstrap';

import { LocalStorage } from '@client/utils/local-storage';

import en from './locales/en.json';
import es from './locales/es.json';

const { locale: bootstrapLocale } = getBootstrap();

let savedLocale = LocalStorage.get('locale');

if (bootstrapLocale) {
  if (locales[bootstrapLocale] || locales.enUS) {
    if (savedLocale) {
      savedLocale.lang = bootstrapLocale;
    } else {
      savedLocale = { lang: bootstrapLocale };
    }

    setDefaultOptions({
      locale: locales[savedLocale.lang] || locales.enUS
    });
  }
} else {
  if (!savedLocale) {
    LocalStorage.create('locale', { lang: 'en' });
  } else {
    setDefaultOptions({
      locale: locales[savedLocale.lang] || locales.enUS
    });
  }
}

// TODO: Future Kieran
// Switch to register() once code-splitting changes are merged
addMessages('en', en);
addMessages('en_US', en);
addMessages('es', es);
addMessages('es_ES', es);

init({
  fallbackLocale: 'en',
  initialLocale: savedLocale?.lang ?? 'en'
});

locale.subscribe((lang) => LocalStorage.update('locale', { lang }));
